import { styled } from '@teko/ds-desktop';
import React from 'react';
import { EnhancedImage } from '../EnhancedImage/EnhancedImage.es.js';

const SmallImage = ({
  image,
  isActive,
  extra,
  onClick,
  onMouseEnter,
  width = 50,
  height = 50,
  borderRadius = 4,
  borderColor = "transparent",
  borderWidth = 1
}) => {
  return /* @__PURE__ */ React.createElement(Wrapper, {
    isActive: !!isActive,
    onClick,
    onMouseEnter,
    width,
    height,
    borderRadius,
    borderColor,
    borderWidth
  }, /* @__PURE__ */ React.createElement(EnhancedImage, {
    src: image.src,
    alt: image.alt,
    objectFit: "contain",
    borderRadius,
    width,
    height
  }), extra && /* @__PURE__ */ React.createElement(Extra, null, extra));
};
const Wrapper = styled.div(({
  isActive,
  theme,
  width,
  height,
  borderRadius,
  borderColor,
  borderWidth
}) => `
  border-radius: ${typeof borderRadius === "string" ? borderRadius : `${borderRadius}px`};
  border: ${typeof borderWidth === "string" ? borderWidth : `${borderWidth}px`} solid ${isActive ? theme == null ? void 0 : theme.colors.primary500 : borderColor};
  position: relative;
  cursor: pointer;
  width: ${typeof width === "string" ? width : `${width}px`};
  height: ${typeof height === "string" ? height : `${height}px`};
  overflow: hidden;
`);
const Extra = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
`;

export { SmallImage };
